"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildRows = void 0;
var react_1 = __importDefault(require("react"));
var Styled = __importStar(require("../Table.styled"));
var renderItemCell = function (cell, originColumn, cellIndex) {
    var _a = cell.getCellProps(), key = _a.key, props = __rest(_a, ["key"]);
    var CellWrapper = originColumn.CellWrapper, cellStyle = originColumn.cellStyle, width = originColumn.width, isStickyColumn = originColumn.sticky;
    var Wrapper = CellWrapper || Styled.Td;
    var wrapperProps = __assign(__assign(__assign({}, props), cellStyle), { width: width,
        isStickyColumn: isStickyColumn,
        cellIndex: cellIndex, 'data-is-sticky-column': isStickyColumn || undefined, 'data-cell-index': isStickyColumn ? cellIndex : undefined });
    return (react_1.default.createElement(Wrapper, __assign({ key: key }, wrapperProps), cell.render('Cell')));
};
var buildRows = function (page, prepareRow, originalColumns) {
    return page.map(function (row, rowIndex) {
        prepareRow(row);
        return (react_1.default.createElement("tr", { key: rowIndex }, row.cells.map(function (cell, cellIndex) {
            return renderItemCell(cell, originalColumns[cellIndex], cellIndex);
        })));
    });
};
exports.buildRows = buildRows;
//# sourceMappingURL=buildRows.js.map